import { Component, OnInit, Input, inject, output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhoneList } from 'src/app/modules/user-profile/models/contact-oeds-person.model';
import { ContactVerificationService } from 'src/app/modules/user-profile/services/contact-verification-service';


@Component({
    selector: 'app-contact-verification-phone-form',
    templateUrl: './contact-verification-phone-form.component.html',
    styleUrls: ['./contact-verification-phone-form.component.css'],
    imports: [FormsModule, ReactiveFormsModule]
})
export class ContactVerificationPhoneFormComponent implements OnInit {
  cservice = inject(ContactVerificationService);

  phoneform: UntypedFormGroup;
  exphone: PhoneList;
  readonly close = output<any>();
  readonly doCancel = output<any>();
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() selectedphone: PhoneList;
  ngOnInit() {
    this.exphone = Object.assign({}, this.selectedphone);
    const numberpattern = '^[0-9]*$';
    this.phoneform = new UntypedFormGroup({
      areacode: new UntypedFormControl({ value: '' }, Validators.compose([Validators.required, Validators.pattern(numberpattern)])),
      phonenumber: new UntypedFormControl({ value: '' }, Validators.compose([Validators.required, Validators.pattern(numberpattern)]))
    });
  }
  cancel() {
    var exphonelist = this.cservice.oedsPersonCopy.phoneList;
    Object.assign(this.cservice.filterPhoneByType(this.selectedphone.oedsPhoneType, exphonelist)[0], this.exphone);
    this.doCancel.emit(null);
  }
  update() {
    if (this.selectedphone.oedsPhoneKey == 0)
      this.selectedphone.actionType = "Inserted";
    else
      this.selectedphone.actionType = "Updated";
    this.doCancel.emit(null);
  }
  setPrimaryfalg(e) {
    this.selectedphone.primaryFlag = e.target.checked;
  }
  addHyphen(evt) {
    let number = evt.target.value;
    if (number.length > 3)
      this.selectedphone.phoneNumberDisplay = number.substring(0, 3) + "-" + number.substring(3, 7);
    else
      this.selectedphone.phoneNumberDisplay = number;
  }
}
